import _classCallCheck from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { globalThis, document } from "./utils/server-safe-globals.js";
import { getStringAttr, setStringAttr } from "./utils/element-utils.js";
var Attributes = {
  PLACEHOLDER_SRC: "placeholdersrc",
  SRC: "src"
};
var template = document.createElement("template");
template.innerHTML = "\n  <style>\n    :host {\n      pointer-events: none;\n      display: var(--media-poster-image-display, inline-block);\n      box-sizing: border-box;\n    }\n\n    img {\n      max-width: 100%;\n      max-height: 100%;\n      min-width: 100%;\n      min-height: 100%;\n      background-repeat: no-repeat;\n      background-position: var(--media-poster-image-background-position, var(--media-object-position, center));\n      background-size: var(--media-poster-image-background-size, var(--media-object-fit, contain));\n      object-fit: var(--media-object-fit, contain);\n      object-position: var(--media-object-position, center);\n    }\n  </style>\n\n  <img part=\"poster img\" aria-hidden=\"true\" id=\"image\"/>\n";

var unsetBackgroundImage = function unsetBackgroundImage(el) {
  el.style.removeProperty("background-image");
};

var setBackgroundImage = function setBackgroundImage(el, image) {
  el.style["background-image"] = "url('".concat(image, "')");
};

var MediaPosterImage = /*#__PURE__*/function (_globalThis$HTMLEleme) {
  _inherits(MediaPosterImage, _globalThis$HTMLEleme);

  var _super = _createSuper(MediaPosterImage);

  function MediaPosterImage() {
    var _this;

    _classCallCheck(this, MediaPosterImage);

    _this = _super.call(this);

    if (!_this.shadowRoot) {
      _this.attachShadow({
        mode: "open"
      });

      _this.shadowRoot.appendChild(template.content.cloneNode(true));
    }

    _this.image = _this.shadowRoot.querySelector("#image");
    return _this;
  }

  _createClass(MediaPosterImage, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, _oldValue, newValue) {
      if (attrName === Attributes.SRC) {
        if (newValue == null) {
          this.image.removeAttribute(Attributes.SRC);
        } else {
          this.image.setAttribute(Attributes.SRC, newValue);
        }
      }

      if (attrName === Attributes.PLACEHOLDER_SRC) {
        if (newValue == null) {
          unsetBackgroundImage(this.image);
        } else {
          setBackgroundImage(this.image, newValue);
        }
      }
    }
  }, {
    key: "placeholderSrc",
    get: function get() {
      return getStringAttr(this, Attributes.PLACEHOLDER_SRC);
    },
    set: function set(value) {
      setStringAttr(this, Attributes.SRC, value);
    }
  }, {
    key: "src",
    get: function get() {
      return getStringAttr(this, Attributes.SRC);
    },
    set: function set(value) {
      setStringAttr(this, Attributes.SRC, value);
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return [Attributes.PLACEHOLDER_SRC, Attributes.SRC];
    }
  }]);

  return MediaPosterImage;
}(globalThis.HTMLElement);

if (!globalThis.customElements.get("media-poster-image")) {
  globalThis.customElements.define("media-poster-image", MediaPosterImage);
}

var media_poster_image_default = MediaPosterImage;
export { Attributes, media_poster_image_default as default };